import axios from 'axios';
import Config from '../../misc/Config';

const API_URL = Config.GFU_API_URL + '/contacts';
const filter = (filter) => (filter) ? '?filter=' + filter : '';
const state = {
    contacts: [],
    contact: null,
    isBusy: false,
};
const getters = {
    contacts: (state) => state.contacts,
    contact: (state) => state.contact   
};
const actions = {
    /**
     * @todo: remove see /views/delme.OfferCreateDebug.vue
     */
    async fetchContacts({ commit }, params) {
        
        let response = null;
        if(params && params.companyId)
            response = await axios.get(API_URL + '/' + params.companyId + '/by-company' + filter(params.search));
        else {
            response = await axios.get(API_URL + ((params && params.search) ? filter(params.search) : ''));
        }
        commit('setContacts', response.data.items);
    },
    async fetchContact({ commit }, id) {
        const response = await axios.get(API_URL + '/' + id + '/by-ref')
        commit('setContact', response.data);
    }
};
const mutations = {
    setContacts: (state, contacts) => state.contacts = contacts,
    setContact: (state, contact) => state.contact = contact,
};

export default {
    state,
    getters,
    actions,
    mutations,
}